<template xmlns:v-for="http://www.w3.org/1999/xhtml">
    <div>
        <b-container fluid>
            <!-- User Interface controls -->
            <b-row>
                <b-col md="6" class="my-1">
                    <b-form-group horizontal label="Выберите бренд" class="">
                    <b-form-select v-model="selectedBranch" :options="selectBrands" class="mr-1">
                        <option slot="first" :value="null">-- Не выбрана --</option>
                    </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="6" class="my-1">

                <b-form-group horizontal label="Поиск клиента:" class="">
                        <b-input-group class="d-flex">
                            <!--<b-form-input v-model="filter" placeholder="Введите для поиска" />-->
                            <the-mask class="flex-grow-1 pl-2 pr-2" :masked="true" mask="8 (###) ###-##-##"  v-model="filter" placeholder="8 (###) ##-##-##"/>
                            <b-input-group-append>
                                <b-btn :disabled="!filter" @click="filter = ''">Очистить</b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-table hover
                         show-empty
                         :empty-text="emptyText"
                         :fields="fields"
                         :items="ordersByTel"
                >
                    <template slot="time" slot-scope="data">
                        {{data.item.time | date}}<br><b>{{data.item.time | time}}</b><br>
                      <b>На день:</b> {{data.item.forDay | date}}
                    </template>
                    <!--<template slot="time" slot-scope="data">-->
                        <!--{{data.item.date | diffTime(data.item.dateFinish)}}-->
                    <!--</template>-->
                    <template slot="productsName" slot-scope="data">
                        <div class="itemGrid" v-for="product in data.item.prods.nodes" v-bind:key="product.id">
                            <span>{{product.name}}</span><span class="prodDet"><span></span><span class="prodCount">{{product.count}}</span><span>x</span><span class="prodCost">{{product.cost > 0 ? product.cost + '&#8381;' : product.pricePoints + 'Б.'}}</span></span>
                        </div>
                    </template>
                    <template slot="productsSumCost" slot-scope="data">
                            {{calcSumOrder(data.item.prods.nodes)}} &#8381;<br>
                    </template>
                    <template slot="orderCost" slot-scope="data">
                        {{data.item.price}} &#8381;<br>
                        {{data.item.pricePoints > 0 ? (data.item.pricePoints + ' Б.') : ''}}
                    </template>
                    <template slot="delivery" slot-scope="data">
                        {{(data.item.typeDelivery.keyword === constDelivery.DELIVERY) ? fullAddress(data.item) : data.item.typeDelivery.name}}
                    </template>
                    <template slot="client" slot-scope="data">
                        <template v-if="data.item.client">
                            {{data.item.client.name ? data.item.client.name : 'Не указано'}}<br>{{data.item.client.phone}}
                        </template>
                        <template v-if="!data.item.client">
                            {{data.item.fio ? data.item.fio : 'Не указано'}} (не авториз.)<br>{{data.item.phone}}
                        </template>
                    </template>
                    <template slot="typePayment" slot-scope="typePayment">
                        {{typePayment.value.name}}
                    </template>
                    <template slot="branch" slot-scope="data">
                        {{data.item.point ? data.item.point.address : 'Не выбрана'}}
                    </template>
                    <template slot="status" slot-scope="status">
                        {{status.value.name}}
                    </template>
                    <template slot="edit" slot-scope="data">
                        <b-button size="md" @click="$emit('repeat-order', data.item)" variant="info" v-if="data.item.status.keyword !== constStatus.NEW">Повторить заказ</b-button>
<!--                        <b-button size="md" @click="$emit('repeat-order', data.item)" variant="success" v-if="data.item.status.keyword === constStatus.NEW">Подтвердить заказ</b-button>-->
                    </template>
                </b-table>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import {
  ORDERS_BY_PHONE,
  BRANDS_QUERY
} from '@/constants/graphql'
import {ru} from 'vuejs-datepicker/dist/locale'
import orderFunc from '@/functionsLib/orderFunc'
import {
  TYPE_DELIVERY,
  TYPE_PAYMENT,
  TYPE_DISCOUNT,
  STATUS_ORDER
} from '@/constants/keywords'
// import orderFunc from '@/functionsLib/orderFunc'
export default {
  name: 'ListOrders',
  apollo: {
    pointsOptions: {
      query: BRANDS_QUERY,
      update (data) {
        let points = data.allBrands.nodes
        this.selectBrands = points.map(el => {
          return {
            value: el,
            text: el.name
          }
        })
        return points
      }
    },
    ordersByTel: {
      query: ORDERS_BY_PHONE,
      variables () {
        return {
          idBrand: this.selectedBranch ? this.selectedBranch.id : 0,
          phone: this.filter
        }
      },
      fetchPolicy: 'network-only',
      update (data) {
        return data.allOrders.nodes
      }
    }
  },
  data: function () {
    return {
      selectedBranch: null,
      selectBrands: [],
      constDelivery: TYPE_DELIVERY,
      constPayment: TYPE_PAYMENT,
      constDiscount: TYPE_DISCOUNT,
      constStatus: STATUS_ORDER,
      ru: ru,
      dateOptions: {
        0: 'Сегодня ' + this.$moment().format('L'),
        1: 'Вчера ' + this.$moment().subtract(1, 'days').format('L'),
        2: 'Неделя ' + this.$moment().subtract(7, 'days').format('L') + ' - ' + this.$moment().format('L'),
        3: 'Месяц ' + this.$moment().subtract(30, 'days').format('L') + ' - ' + this.$moment().format('L'),
        4: 'Период'
      },
      sortBy: 'date',
      fields: [
        {
          key: 'id',
          label: 'Заказ'
        },
        {
          key: 'time',
          label: 'Дата'
        },
        {
          key: 'productsName',
          label: 'Состав заказа'
        },
        {
          key: 'productsSumCost',
          label: 'Сумма'
        },
        {
          key: 'orderCost',
          label: 'Итого'
        },
        {
          key: 'comment',
          label: 'Комментарий'
        },
        {
          key: 'delivery',
          label: 'Доставка'
        },
        {
          key: 'client',
          label: 'Клиент'
        },
        {
          key: 'typePayment',
          label: 'Тип оплаты'
        },
        {
          key: 'branch',
          label: 'Точка'
        },
        {
          key: 'status',
          label: 'Статус'
        },
        {
          key: 'edit',
          label: 'Управление'
        }
      ],
      filter: '8 (123) 123-12-31',
      filterStatus: null,
      filterDate: 0,
      emptyText: 'Не найдено заказов по указанным критериям'
    }
  },
  methods: {
    updateOrders () {
      this.$apollo.queries.ordersByTel.refetch()
    },
    copyObj (obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    calcSumOrder: function (prods) {
      return prods.reduce((accum, prod) => (accum + prod.cost * prod.count), 0)
    },
    itemProdsFormat: function (prods) {
      let len = 0
      prods.map((curr) => {
        len = Math.max(len, curr.name.length)
      })
      prods.forEach((val, ind) => {
        prods[ind].name = val.name.padStart(10, String.fromCharCode(160))
      })

      return prods
    },
    fullAddress: orderFunc.fullAddress,
    filterFunc: function (item) {
      let check = true
      check &= this.filterStatus === null || this.filterStatus === item.status
      check &=
            new RegExp('.*' + this.filter.toLowerCase() + '.*').test(item.client.name.toLowerCase()) ||
            new RegExp('.*' + this.filter + '.*').test(item.client.phone)
      return check
    },
    updateOrderParams () {
      this.calcAverageSum()
      this.updateLength()
    },
    calcAverageSum: function () {
      if (!this.orders) {
        return 0
      }
      let sum = this.orders.reduce((sum, item) => (sum + item.orderCost), 0)
      this.$emit('average-sum', sum / this.orders.length)
    },
    updateLength () {
      this.$emit('orders-length', this.orders ? this.orders.length : 0)
    }
  },
  props: ['statusOptions']
}
</script>

<style lang="scss" scoped>
    .itemGrid {
        display:flex;
        justify-content: space-between;
        .prodDet {
            display:flex;
            justify-content: space-between;
            width: 100px;
            .prodCount {
                min-width: 18px;
                text-align: center;
            }
            .prodCost {
                min-width: 50px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ListOrders.vue